// app/javascript/controllers/auto_open_modal_controller.js

import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
    connect() {
        this.modal = Modal.getOrCreateInstance(this.element, {
            backdrop: "static",
            keyboard: false,
        })

        requestAnimationFrame(() => {
            this.modal.show()
        })
    }

    disconnect() {
        if (!this.modal) return

        this.modal.hide()
        this.modal.dispose()
    }
}